export var VerifyStatusEnum;
(function (VerifyStatusEnum) {
    VerifyStatusEnum["verified"] = "verified";
    VerifyStatusEnum["partial"] = "partial";
    VerifyStatusEnum["notVerified"] = "notVerified";
})(VerifyStatusEnum || (VerifyStatusEnum = {}));
